import { createContext, useState } from 'react';
import { useSelector } from 'react-redux';

// ==============================|| CONFIG CONTEXT & PROVIDER ||============================== //

export const ChatContext = createContext({});

function ChatContextWrapper({
	url,
	context,
	bottomRef,
	children,
	roomId,
	image,
	setImage,
	file,
	setFile,
	selectedUser = {},
	setSelectedUser = () => {},
	conversations,
	setConversations,
	reply,
	setReply,
	status,
	onSendEditHandler,
	onSendDeleteHandler,
	chatCountOfUser,
	setChatCountOfUser,
}) {
	const [editMessage, setEditMessage] = useState(null);

	const userId = useSelector((state) => state?.profile?.profileData?.userId);
	const companyCode = useSelector((state) => state?.profile?.profileData?.creatorOrganizationId);

	return (
		<ChatContext.Provider
			value={{
				url,
				roomId,
				context,
				bottomRef,
				selectedUser,
				setSelectedUser,
				conversations,
				setConversations,
				editMessage,
				setEditMessage,
				reply,
				setReply,
				status,
				onSendEditHandler,
				onSendDeleteHandler,
				image,
				setImage,
				file,
				setFile,
				chatCountOfUser,
				setChatCountOfUser,
				userId,
				companyCode,
			}}
		>
			{children}
		</ChatContext.Provider>
	);
}

export default ChatContextWrapper;
